(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
    function loadSecondaryImage(event) {
      if (event.type === 'pointerover' && event.pointerType === 'touch') return;
      if (!(event.target instanceof Element)) return;
      const card = event.target.closest('.card-wrapper');
      if (!card) return;
      card.querySelectorAll('img[data-ep-hover-src]').forEach((image) => {
        if (image.dataset.epHoverLoading) return;
        image.dataset.epHoverLoading = 'true';
        const revealSecondaryImage = () => {
          if (!image.complete || !image.naturalWidth || image.currentSrc.startsWith('data:')) return;
          image.parentElement.classList.remove('ep-card-media-pending');
          image.removeAttribute('data-ep-hover-src');
          image.removeAttribute('data-ep-hover-srcset');
          image.removeEventListener('load', revealSecondaryImage);
        };
        image.addEventListener('load', revealSecondaryImage);
        image.loading = 'eager';
        image.srcset = image.getAttribute('data-ep-hover-srcset');
        image.src = image.getAttribute('data-ep-hover-src');
        revealSecondaryImage();
      });
    }
    document.addEventListener('pointerover', loadSecondaryImage, { passive: true });
    document.addEventListener('focusin', loadSecondaryImage);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ep-shipping-progress"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('ep-shipping-progress')) return;

  class EpShippingProgress extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold);
      this.tiers = JSON.parse(this.dataset.tiers || '{}');
      this.message = this.querySelector('[data-shipping-message]');
      this.bar = this.querySelector('[data-shipping-bar]');
      this.update({
        total_price: Number(this.dataset.total),
        total_weight: Number(this.dataset.weight),
        item_count: Number(this.dataset.count),
        currency: this.dataset.currency,
      });
    }

    update(cart) {
      const total = Number(cart.total_price);
      const weight = Number(cart.total_weight);
      this.threshold = Number(this.tiers[this.dataset.country] || 0);
      const eligible =
        this.threshold > 0 &&
        cart.currency === 'USD' &&
        Number(cart.item_count) > 0 &&
        Number.isFinite(this.threshold) && this.threshold > 0 &&
        Number.isFinite(total) && total >= 0 &&
        Number.isFinite(weight);

      this.hidden = !eligible;
      if (!eligible) return;

      const remaining = Math.max(0, this.threshold - Math.round(total));
      let money;
      try {
        money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol',
        }).format(remaining / 100) + ' USD';
      } catch {
        money = (remaining / 100).toFixed(2) + ' USD';
      }

      this.message.textContent = remaining === 0
        ? this.dataset.reachedMessage
        : this.dataset.remainingTemplate.replace('__amount__', money);
      this.bar.max = this.threshold;
      this.bar.value = Math.min(this.threshold, total);
      this.dataset.reached = String(remaining === 0);
    }
  }

  customElements.define('ep-shipping-progress', EpShippingProgress);

  let requestVersion = 0;
  const refresh = async (cart) => {
    const version = ++requestVersion;
    try {
      if (!cart || typeof cart.total_price !== 'number' || typeof cart.total_weight !== 'number') {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Cart unavailable');
        cart = await response.json();
      }
      if (version !== requestVersion) return;
      document.querySelectorAll('ep-shipping-progress').forEach((element) => element.update(cart));
    } catch {
      if (version === requestVersion) {
        document.querySelectorAll('ep-shipping-progress').forEach((element) => { element.hidden = true; });
      }
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => refresh(event.cartData));
  }
})();
  } catch(e) { console.error(e); }
})();

})();
